"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = BalanceDonut;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _reactNative = require("react-native");
var _reactNativeSvg = _interopRequireWildcard(require("react-native-svg"));
var _renderprops = require("react-spring/renderprops");
var _reactSpring = require("react-spring");
var _components = require("@sart/components");
var _styles = require("@sart/styles");
var _client = require("@sart/client");
var _excluded = ["loading", "title", "unit", "maxAmount", "amountRemaining", "color", "fontSize", "onPress", "unitColor", "valueColor", "displayAmount"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var isSmallDevice = _reactNative.Dimensions.get('window').height < 750 ? true : false;
var totalWidth = isSmallDevice < 750 ? 110 : 120;
var strokeWidth = isSmallDevice ? 8 : 10;
var diameter = totalWidth - strokeWidth;
var radius = diameter / 2;
var circumference = 2 * Math.PI * radius;
function BalanceDonut(props) {
  var loading = props.loading,
    title = props.title,
    unit = props.unit,
    maxAmount = props.maxAmount,
    amountRemaining = props.amountRemaining,
    color = props.color,
    fontSize = props.fontSize,
    onPress = props.onPress,
    unitColor = props.unitColor,
    valueColor = props.valueColor,
    displayAmount = props.displayAmount,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var _useState = (0, _react.useState)(0),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    ratio = _useState2[0],
    setRatio = _useState2[1];
  var AnimatedPath = (0, _renderprops.animated)(_reactNativeSvg.Path);
  var AnimatedCircle = (0, _renderprops.animated)(_reactNativeSvg.Circle);
  var AnimatedSvg = _reactNative.Animated.createAnimatedComponent(_reactNativeSvg["default"]);
  var SpringKeyframes = _renderprops.Keyframes.Spring({
    show: {
      stroke: color
    },
    pulsing: function () {
      var _pulsing = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(next) {
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!1) {
                _context.next = 3;
                break;
              }
              _context.next = 1;
              return next({
                stroke: '#E7EAEE'
              });
            case 1:
              _context.next = 2;
              return next({
                stroke: _styles.colors.common
              });
            case 2:
              _context.next = 0;
              break;
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function pulsing(_x) {
        return _pulsing.apply(this, arguments);
      }
      return pulsing;
    }()
  });
  var _useClient = (0, _client.useClient)(),
    _useClient$cache = _useClient.cache,
    _useClient$cache2 = _useClient$cache === void 0 ? {} : _useClient$cache,
    userTheme = _useClient$cache2.userTheme;
  (0, _react.useEffect)(function () {
    if (!loading) {
      if (!isNaN(amountRemaining)) {
        setRatio(amountRemaining / maxAmount);
      } else if (amountRemaining === 'unl') {
        setRatio(1);
      } else {
        setRatio(0);
      }
    } else {
      setRatio(0);
    }
  }, [loading, amountRemaining]);
  var totalPathLength = circumference;
  var strokeDashoffset = totalPathLength - totalPathLength * ratio;
  var amountToDisplay = amountRemaining === 'unl' ? 'unl' : isNaN(amountRemaining) || amountRemaining === 0 && maxAmount === 0 ? 0 : amountRemaining;
  return /*#__PURE__*/_react["default"].createElement(_reactNative.TouchableOpacity, {
    style: {
      alignItems: 'center'
    },
    onPress: onPress,
    disabled: loading
  }, /*#__PURE__*/_react["default"].createElement(_reactNative.Text, {
    style: [_objectSpread({
      color: color
    }, _styles.typography.extraBold), isSmallDevice ? {
      fontSize: 13
    } : {
      fontSize: fontSize
    }]
  }, title ? title.toUpperCase() : ''), !isSmallDevice && /*#__PURE__*/_react["default"].createElement(_components.Space, {
    height: 8
  }), isSmallDevice && /*#__PURE__*/_react["default"].createElement(_components.Space, {
    height: 4
  }), /*#__PURE__*/_react["default"].createElement(AnimatedSvg, (0, _extends2["default"])({
    viewBox: "-60 -60 120 120",
    height: "100",
    width: "100"
  }, rest), /*#__PURE__*/_react["default"].createElement(_reactNativeSvg.G, {
    fill: "none",
    strokeWidth: strokeWidth,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeSvg.Circle, {
    stroke: "#E7EAEE",
    cx: 0,
    cy: 0,
    r: radius
  }), loading && /*#__PURE__*/_react["default"].createElement(SpringKeyframes, {
    "native": true,
    state: loading ? "pulsing" : "show",
    config: {
      duration: 400
    }
  }, function (circleStyle) {
    return /*#__PURE__*/_react["default"].createElement(AnimatedCircle, {
      stroke: circleStyle.stroke,
      cx: 0,
      cy: 0,
      r: radius,
      transform: "rotate(90) scale(1,-1)",
      strokeDasharray: "".concat(totalPathLength, " ").concat(totalPathLength),
      strokeDashoffset: strokeDashoffset
    });
  }), !loading && /*#__PURE__*/_react["default"].createElement(_renderprops.Spring, {
    "native": true,
    config: {
      duration: 1500
    },
    from: {
      strokeDashoffset: amountRemaining === 0 ? undefined : 315
    },
    to: {
      strokeDashoffset: strokeDashoffset
    }
  }, function (styles) {
    return /*#__PURE__*/_react["default"].createElement(AnimatedCircle, {
      stroke: color,
      cx: 0,
      cy: 0,
      r: radius,
      transform: "rotate(-90) scale(1,1)",
      strokeDasharray: "".concat(totalPathLength, " ").concat(totalPathLength),
      strokeDashoffset: styles.strokeDashoffset
    });
  })), /*#__PURE__*/_react["default"].createElement(_reactNativeSvg.G, {
    fill: valueColor,
    fontFamily: _styles.typography.defaultFontFamily,
    textAnchor: "middle"
  }, !loading && !displayAmount && /*#__PURE__*/_react["default"].createElement(_reactNativeSvg.Text, {
    x: "0",
    y: "-13",
    fontSize: 18,
    color: valueColor,
    fontWeight: '500'
  }, amountToDisplay), displayAmount && /*#__PURE__*/_react["default"].createElement(_reactNativeSvg.Text, {
    x: "0",
    y: "-13",
    fontSize: 18,
    color: valueColor,
    fontWeight: '500'
  }, displayAmount)), !loading && /*#__PURE__*/_react["default"].createElement(_reactNativeSvg.G, {
    fill: unitColor,
    fontFamily: _styles.typography.defaultFontFamily,
    textAnchor: "middle"
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeSvg.Text, {
    x: "0",
    y: "0",
    fontSize: 12
  }, unit)), loading && /*#__PURE__*/_react["default"].createElement(_reactNativeSvg.Text, {
    x: "0",
    y: "-13",
    fontSize: 18,
    color: valueColor,
    fontWeight: '500'
  }, "LOADING")));
}